/* eslint-disable no-underscore-dangle, @typescript-eslint/no-unused-vars */
import React, {
  useState,
  useEffect,
  Fragment,
  useCallback,
  useRef,
} from 'react';
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Button,
  Label,
  Input,
} from 'reactstrap';
import { ReactSortable } from 'react-sortablejs';
import { capitalize } from 'lodash';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faArrowUp,
  faArrowDown,
  faTrash,
  faPlus,
  faSave,
} from '@fortawesome/free-solid-svg-icons';
import { faFigma } from '@fortawesome/free-brands-svg-icons';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Formik, ErrorMessage, FormikProps } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import NavigationPrompt from 'react-router-navigation-prompt';
import defaultComponentCover from '../../../assets/images/default-component.png';
import prototypeApi from '../../../api/prototypeApi';
import componentApi from '../../../api/componentApi';
import { get as getLsValue } from '../../../helpers/local-storage';
import { getSanitizedS3BucketUrl } from '../../../helpers';
import FloatBtnGroup from '../../../components/common/FloatBtnGroup';
import FloatBtn from '../../../components/common/FloatBtn';
import PageLoading from '../../../components/common/pageLoad';
import MoodboardOptions from '../components/moodboardOptions';
import DragAndDropField from '../../../components/FormFields/DragAndDropField';
import Alert from '../../../components/common/Alert';
import {
  MOODBOARD_EMAIL_HEADING,
  MOODBOARD_EMAIL_MESSAGE,
  MOODGEN_READY,
  APPROVED,
} from '../../../constants';

const SweetAlert = withReactContent(Swal);
export interface ItemType {
  id: string;
  _id: string;
  wireFrameImage: string;
  designImage: string;
  page?: string;
  project?: string;
  isInRealm: boolean;
  pageComponentId: string;
  projectId: string;
  types: any;
  pageId: string;
  isRevised: boolean;
  isReference: boolean;
  order: number;
  referenceId: string | null;
  sectionFigmaUrl?: string;
}

const EditPageMoodboard = (props: {
  match: {
    params: { prototypeId: string; pageId: string };
  };
  history: any;
  location: {
    prototypeName: any;
    pageName: any;
    state: {
      prototypeName: string;
      pageName: string;
      checkedValue: any;
      status: number;
    };
  };
}) => {
  const {
    match: {
      params: { prototypeId, pageId: prototypePageId },
    },
    location,
    history,
  } = props;
  const revisionFormRef = useRef<FormikProps<any>>(null);
  const addNewFormRef = useRef<FormikProps<any>>(null);
  const isMountedRef = useRef(true);

  const [items, setItems] = useState<ItemType[]>([]);
  const [prototypeName, setPrototypeName] = useState<string>('');
  const [pageName, setPageName] = useState<string>('');
  const [responseCount, setResponseCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isLandingPageUpdated, setIsLandingPageUpdated] =
    useState<boolean>(false);
  const [selectedRevisionItem, setSelectedRevisionItem] = useState<ItemType>();
  const [revisionItem, setRevisionItem] = useState<any>();
  const [initialValues, setInitialValues] = useState<{
    sections: Array<{
      wireFrameImage: string;
      sectionFigmaUrl: string;
    }>;
  }>({
    sections: [
      {
        wireFrameImage: '',
        sectionFigmaUrl: '',
      },
    ],
  });
  const [isFileUploading, setIsFileUploading] = useState<{
    [key: string]: boolean;
  }>({});
  const [tempComponentId, setTempComponentId] = useState<string>('');
  const [isRevisionUpdated, setIsRevisionUpdated] = useState<boolean>(false);
  const [isFormUpdated, setIsFormUpdated] = useState<boolean>(false);
  const [leaveAlertOpen, setLeaveAlertOpen] = useState<boolean>(false);
  const [addSectionModal, setAddSectionModal] = useState<boolean>(false);
  const [addSectionIndex, setAddSectionIndex] = useState<number>(-1);

  const [revisionModal, setRevisionModal] = React.useState(false);
  const [revisionViewModal, setRevisionViewModal] = React.useState(false);
  const revisionToggle = () => {
    setRevisionModal(!revisionModal);
  };
  const revisionViewToggle = () => {
    setRevisionViewModal(!revisionViewModal);
  };

  const addSectionToggle = () => {
    setAddSectionModal(!addSectionModal);
  };

  const addNewSection = () => {
    const activeFormRef = addSectionModal ? addNewFormRef : revisionFormRef;
    const currentValues = activeFormRef.current?.values;
    const currentSections = currentValues?.sections || initialValues.sections;

    setInitialValues({
      sections: [
        ...currentSections,
        {
          wireFrameImage: '',
          sectionFigmaUrl: '',
        },
      ],
    });
  };

  const removeSection = (index: number) => {
    const activeFormRef = addSectionModal ? addNewFormRef : revisionFormRef;
    const currentValues = activeFormRef.current?.values;
    const currentSections = currentValues?.sections || initialValues.sections;

    if (currentSections.length > 1) {
      const newSections = currentSections.filter(
        (_: { wireFrameImage: string; sectionFigmaUrl: string }, i: number) =>
          i !== index,
      );

      setInitialValues({
        sections: newSections,
      });

      if (activeFormRef.current) {
        activeFormRef.current.resetForm({ values: { sections: newSections } });
      }
    }
  };

  const getPageComponent = async (prototype: string, pageToGet: string) => {
    setIsLoading(true);
    try {
      const results = await prototypeApi.getPageComponent(prototype, pageToGet);
      setResponseCount(results.data.data.length);
      if (results.data.data && results.data.data.length > 0) {
        const newPageComponent = results.data.data.map((item: any) => {
          const {
            component_id: id,
            wireFrameImage,
            designImage,
            page,
            project,
            is_in_realm: isInRealm,
            page_component_id: pageComponentId,
            project_id: projectId,
            types,
            page_id: pageId,
            isRevised,
            isReference,
            order,
            reference_id: referenceId,
            sectionFigmaUrl,
          } = item;

          return {
            _id: id,
            id,
            wireFrameImage,
            designImage,
            page,
            project,
            isInRealm,
            pageComponentId,
            projectId,
            types,
            pageId,
            isRevised: isRevised || false,
            isReference: isReference || false,
            order,
            referenceId: referenceId || null,
            sectionFigmaUrl,
          };
        });
        if (isMountedRef.current) {
          setItems(newPageComponent);
        }
      } else if (isMountedRef.current) {
        setItems([]);
      }
    } catch (e) {
      const error = e as any;
      if (error.response && error.response.status) {
        // eslint-disable-next-line no-console
        console.error('component get error', error.response);
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (location && location.state) {
      if (Array.isArray(location.state.checkedValue)) {
        setItems(location.state.checkedValue);
      } else {
        getPageComponent(prototypeId, prototypePageId);
      }
      if (location.state.prototypeName) {
        setPrototypeName(location.state.prototypeName);
      }
      if (location && location.state.pageName) {
        setPageName(location.state.pageName);
      }
    }
    if (location && location.pageName) {
      setPageName(location.pageName);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleCancel = () => {
    history.push({
      pathname: `/moodgen`,
    });
  };

  const saveFunc = async (savedItems: any) => {
    const components = savedItems.map((item: ItemType) => {
      const { id, _id, pageComponentId, isReference, referenceId } = item;
      return {
        componentId: id || _id,
        pageComponentId,
        status: 1,
        isReference,
        // eslint-disable-next-line @typescript-eslint/camelcase
        reference_id: referenceId,
      };
    });

    const saveResponse = await prototypeApi.savePageComponent({
      /* eslint-disable @typescript-eslint/camelcase */
      page_id: prototypePageId,
      prototype_id: prototypeId,
      components,
      /* eslint-enable */
    });
    return saveResponse;
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await saveFunc(items);
      setIsLandingPageUpdated(false);

      toast('Your changes have been saved successfully', {
        type: 'success',
        autoClose: 5000,
      });
      await getPageComponent(prototypeId, prototypePageId);
    } catch (e) {
      toast('Error saving changes. Please try again.', {
        type: 'error',
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    sections: Yup.array().of(
      Yup.object().shape({
        wireFrameImage: Yup.string().required('Wire Frame Image Required'),
        sectionFigmaUrl: Yup.string().url('Must be a valid URL').nullable(),
      }),
    ),
  });

  const s3BucketUrl = getSanitizedS3BucketUrl();
  const formatImageUrl = (url: string) =>
    url && url[0] === '/' ? url.substring(1, url.length) : url;

  const presentationModeIsDesign = getLsValue(
    'theme-setting-show-designs',
    false,
  );

  const [pageMoodboardIsGenerating, setPageMoodboardIsGenerating] = useState<
    string | null
  >(null);

  const handleMoodboardGenerate = async (pageId: string) => {
    if (isLandingPageUpdated) {
      SweetAlert.fire({
        title: 'Unsaved Changes',
        text: 'There are unsaved changes, please save the changes before generating.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      return;
    }
    setPageMoodboardIsGenerating(pageId);
    try {
      await prototypeApi.generatePageMoodboard(prototypeId, pageId);
      setPageMoodboardIsGenerating(null);
      SweetAlert.fire({
        title: MOODBOARD_EMAIL_HEADING,
        text: MOODBOARD_EMAIL_MESSAGE,
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Ok',
      });
    } catch (error) {
      const err = error as any;
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      toast(err.response.data.message, {
        type: 'error',
        autoClose: 5000,
      });
      setPageMoodboardIsGenerating(null);
    }
  };

  const handleRemove = (itemIndex: number) => {
    SweetAlert.fire({
      title: 'Confirm Action',
      text: 'Are you sure you want to remove this section with the MoodGen references?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
    }).then(async (alertResult) => {
      if (alertResult.isConfirmed) {
        setIsLoading(true);
        try {
          const itemsCopy = [...items];
          itemsCopy.splice(itemIndex, 1);
          await saveFunc(itemsCopy);
          toast('Section removed successfully.', {
            type: 'success',
            autoClose: 5000,
          });
          await getPageComponent(prototypeId, prototypePageId);
        } catch (e) {
          toast('Error removing section. Please try again.', {
            type: 'error',
            autoClose: 5000,
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  // Commented out as per the request of https://eight25media.atlassian.net/browse/ARGO-901
  // const handleDuplicate = async (item: any, index: number) => {
  //   const {
  //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //     pageComponentId,
  //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //     isRevised,
  //     ...itemWithoutPageComponentID
  //   } = item;

  //   const existingItems = [...items];
  //   existingItems.splice(index + 1, 0, itemWithoutPageComponentID);
  //   setIsLoading(true);
  //   try {
  //     await saveFunc(existingItems);
  //     toast('The section has been duplicated successfully.', {
  //       type: 'success',
  //       autoClose: 5000,
  //     });
  //     await getPageComponent(prototypeId, prototypePageId);
  //   } catch (e) {
  //     toast('Error duplicating section. Please try again.', {
  //       type: 'error',
  //       autoClose: 5000,
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleMoveUp = (index: number) => {
    if (index > 0) {
      const existingItems = [...items];
      const [item] = existingItems.splice(index, 1);
      existingItems.splice(index - 1, 0, item);
      setItems(existingItems);
      setIsLandingPageUpdated(true);
      return true;
    }
    return false;
  };

  const handleMoveDown = (index: number) => {
    if (index < items.length - 1) {
      const existingItems = [...items];
      const [item] = existingItems.splice(index, 1);
      existingItems.splice(index + 1, 0, item);
      setItems(existingItems);
      setIsLandingPageUpdated(true);
      return true;
    }
    return false;
  };

  const createTempComponentForNewSection = async (order: number) => {
    const selectedComponent = items[order - 1] || {};
    const submitData: any = {
      project: location.state.prototypeName,
      page: pageName,
      componentTypes: selectedComponent.types || [],
      order,
      isByRevision: false,
      isByReference: false,
      image: '',
    };
    let saveResponse;
    try {
      saveResponse = await componentApi.saveRevisionOrReferenceComponent(
        submitData,
      );
    } catch (error) {
      toast('Could not create a temporary section.', { type: 'error' });
      return;
    }
    if (saveResponse) {
      const savedComponent = saveResponse.data.data;
      // eslint-disable-next-line no-underscore-dangle
      setTempComponentId(savedComponent._id);
      addSectionToggle();
    }
  };

  const handleAddNewClick = async (order: number) => {
    setAddSectionIndex(order);
    await createTempComponentForNewSection(order);
  };

  const getRevisionDetails = async (id: string) => {
    let response;
    try {
      response = await prototypeApi.getRevisionDetails(id);
    } catch (error) {
      return;
    }

    if (response) {
      setRevisionItem(response.data.data);
      revisionViewToggle();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const createTempComponent = async (selectedComponent: any, order: number) => {
    if (selectedComponent.isRevised) {
      getRevisionDetails(selectedComponent.pageComponentId);
    } else {
      revisionToggle();
      setSelectedRevisionItem(selectedComponent);
    }
  };

  const removeTempComponent = async () => {
    if (tempComponentId) {
      await prototypeApi.removeComponent({
        componentId: tempComponentId,
        allow: true,
      });
    }
    revisionToggle();
    setTempComponentId('');
    setInitialValues({
      sections: [
        {
          wireFrameImage: '',
          sectionFigmaUrl: '',
        },
      ],
    });
    setIsRevisionUpdated(false);
  };

  const createTempComponentForUpload = useCallback(async () => {
    if (!selectedRevisionItem) return null;

    const submitData: any = {
      project: location.state.prototypeName,
      page: pageName,
      componentTypes: selectedRevisionItem.types,
      order: selectedRevisionItem.order,
      isByRevision: true,
      isByReference: false,
      image: '',
    };
    let saveResponse;
    try {
      saveResponse = await componentApi.saveRevisionOrReferenceComponent(
        submitData,
      );
    } catch (error) {
      return null;
    }
    if (saveResponse) {
      const savedComponent = saveResponse.data.data;
      // eslint-disable-next-line no-underscore-dangle
      const newComponentId = savedComponent._id;
      setTempComponentId(newComponentId);
      return newComponentId;
    }
    return null;
  }, [location.state.prototypeName, pageName, selectedRevisionItem]);

  const removeTempComponentAndCloseAddModal = async () => {
    if (tempComponentId) {
      await prototypeApi.removeComponent({
        componentId: tempComponentId,
        allow: true,
      });
    }
    addSectionToggle();
    setTempComponentId('');
    setInitialValues({
      sections: [
        {
          wireFrameImage: '',
          sectionFigmaUrl: '',
        },
      ],
    }); // Reset form
    setIsFormUpdated(false);
  };

  const handleUploadFile = useCallback(
    async (file, name, values, sectionIndex) => {
      if (!file) return;
      setIsFormUpdated(true);
      if (revisionModal) {
        setIsRevisionUpdated(true);
      }

      const uploadKey = `${name}_${sectionIndex}`;
      setIsFileUploading({
        ...isFileUploading,
        [uploadKey]: true,
      });

      let fileType = '';
      const form = new FormData();
      form.append('image', file);

      switch (name) {
        case 'wireFrameImage':
          fileType = 'wireframe';
          break;
        default:
          fileType = 'wireframe';
          break;
      }
      let componentIdForUpload = tempComponentId;
      if (!componentIdForUpload) {
        componentIdForUpload = await createTempComponentForUpload();
      }
      if (!componentIdForUpload) {
        toast.error(
          'Could not create a temporary component for upload. Please try again.',
        );
        setIsFileUploading({
          ...isFileUploading,
          [uploadKey]: false,
        });
        return;
      }
      const uploadName = await componentApi.upload(
        form,
        fileType,
        componentIdForUpload,
      );
      setIsFileUploading({
        ...isFileUploading,
        [uploadKey]: false,
      });

      const activeFormRef = addSectionModal ? addNewFormRef : revisionFormRef;
      const currentValues = activeFormRef.current?.values;
      const currentSections = currentValues?.sections || [
        ...initialValues.sections,
      ];

      if (name === 'wireFrameImage') {
        currentSections[sectionIndex].wireFrameImage = uploadName.data.fileKey;
      }

      setInitialValues({
        sections: currentSections,
      });
      if (activeFormRef.current) {
        activeFormRef.current.setFieldError(
          `sections.${sectionIndex}.wireFrameImage`,
          undefined,
        );
        activeFormRef.current.setFieldTouched(
          `sections.${sectionIndex}.wireFrameImage`,
          true,
          false,
        );
      }
    },
    [
      tempComponentId,
      initialValues,
      setInitialValues,
      isFileUploading,
      createTempComponentForUpload,
      revisionModal,
      addSectionModal,
    ],
  );

  const handleRevisionSubmitRef = () => {
    if (revisionFormRef.current) {
      revisionFormRef.current.handleSubmit();
    }
  };

  const handleAddNewSubmitRef = () => {
    if (addNewFormRef.current) {
      addNewFormRef.current.handleSubmit();
    }
  };

  const handleRevisionSubmit = async () => {
    const values = revisionFormRef.current?.values;
    if (!values || !values.sections || values.sections.length === 0) return;

    let saveResponse;
    try {
      let componentIdForSubmit = tempComponentId;
      if (!componentIdForSubmit) {
        componentIdForSubmit = await createTempComponentForUpload();
      }

      if (!componentIdForSubmit) {
        toast.error('Could not save revision. Please try again.');
        return;
      }

      const section = values.sections[0];

      await componentApi.save({
        componentId: componentIdForSubmit,
        sectionFigmaUrl: section.sectionFigmaUrl,
        wireFrameImage: section.wireFrameImage,
        // The image and sketch are saved on upload, but we send all data
        // to conform to the existing `createComponents` endpoint
        project: selectedRevisionItem?.project,
        page: selectedRevisionItem?.page,
        componentTypes: selectedRevisionItem?.types
          ?.map((t: any) => {
            if (typeof t === 'string') return t;
            return t?.value || t?._id;
          })
          .filter(Boolean),
        order: selectedRevisionItem?.order,
      });

      saveResponse = await prototypeApi.revisePageComponent(
        selectedRevisionItem?.pageComponentId,
        componentIdForSubmit,
      );
    } catch (error) {
      toast('Error saving revision. Please try again.', { type: 'error' });
      return;
    }

    if (saveResponse) {
      toast('Revision Saved successfully', {
        type: 'success',
        autoClose: 5000,
      });
      await getPageComponent(prototypeId, prototypePageId);
      revisionToggle();
    }
  };
  /* eslint-disable no-underscore-dangle, @typescript-eslint/no-unused-vars */
  interface ComponentResult {
    componentId?: string;
    section: {
      wireFrameImage: string;
      sectionFigmaUrl: string;
    };
    index: number;
  }

  const handleAddNewSubmit = async () => {
    const values = addNewFormRef.current?.values;
    if (!values || !values.sections || values.sections.length === 0) return;

    try {
      // Use the existing save method which handles updates
      const selectedComponent = items[addSectionIndex - 1] || {};
      const componentPromises = values.sections.map(
        (section: any, i: number) => {
          if (!section.wireFrameImage) return Promise.resolve(null);

          if (i === 0) {
            return Promise.resolve({
              componentId: tempComponentId,
              section,
              index: i,
            } as ComponentResult);
          }

          const submitData: any = {
            project: location.state.prototypeName,
            page: pageName,
            componentTypes: selectedComponent.types || [],
            order: addSectionIndex + i,
            isByRevision: false,
            isByReference: false,
            image: '',
          };

          return componentApi.saveRevisionOrReferenceComponent(submitData).then(
            (saveResponse) =>
              ({
                componentId: saveResponse?.data?.data?._id,
                section,
                index: i,
              } as ComponentResult),
          );
        },
      );

      const componentResults = (await Promise.all(componentPromises)).filter(
        Boolean,
      ) as ComponentResult[];
      const newItems = await componentResults.reduce(
        async (itemsPromise, result) => {
          const itemsAccumulator = await itemsPromise;

          if (!result.componentId) {
            toast(
              'Could not create a temporary component for additional section.',
              {
                type: 'error',
              },
            );
            return itemsAccumulator;
          }

          try {
            await componentApi.save({
              componentId: result.componentId,
              sectionFigmaUrl: result.section.sectionFigmaUrl,
              wireFrameImage: result.section.wireFrameImage,
              project: location.state.prototypeName,
              page: pageName,
              componentTypes: (selectedComponent.types || [])
                .map((t: any) => {
                  if (typeof t === 'string') return t;
                  return t?.value || t?._id;
                })
                .filter(Boolean),
              order: addSectionIndex + result.index,
            });

            const newComponentResponse =
              await componentApi.requestComponentById(result.componentId);
            const newComponentData = newComponentResponse.data.component;

            const newItem: ItemType = {
              _id: result.componentId,
              id: result.componentId,
              wireFrameImage: newComponentData.wireFrameImage,
              designImage: newComponentData.designImage,
              page: newComponentData.page.label,
              project: newComponentData.project.label,
              isInRealm: newComponentData.isInRealm,
              pageComponentId: '', // This will be empty until saved.
              types: newComponentData.allComponentTypes,
              pageId: newComponentData.page.value,
              projectId: newComponentData.project.value,
              isRevised: false,
              isReference: false,
              order: addSectionIndex + result.index,
              referenceId: null,
            };

            return [...itemsAccumulator, newItem];
          } catch (error) {
            toast('Error processing component', { type: 'error' });
            return itemsAccumulator;
          }
        },
        Promise.resolve([] as ItemType[]),
      );

      const itemsCopy = [...items];
      itemsCopy.splice(addSectionIndex, 0, ...newItems);
      const orderedItems = itemsCopy.map((item, index) => ({
        ...item,
        order: index + 1,
      }));

      setIsLoading(true);
      try {
        await saveFunc(orderedItems);
        toast(
          `${newItems.length} section${
            newItems.length > 1 ? 's' : ''
          } added successfully.`,
          {
            type: 'success',
            autoClose: 5000,
          },
        );
        await getPageComponent(prototypeId, prototypePageId);
      } catch (err) {
        toast('Could not save added sections.', { type: 'error' });
      } finally {
        setIsLoading(false);
      }
    } catch (error) {
      toast('Could not add sections.', { type: 'error' });
    } finally {
      addSectionToggle();
      setInitialValues({
        sections: [
          {
            wireFrameImage: '',
            sectionFigmaUrl: '',
          },
        ],
      });
      setSelectedRevisionItem(undefined);
      setTempComponentId('');
      if (addNewFormRef.current) addNewFormRef.current.resetForm();
    }
  };

  const deleteRevision = () => {
    SweetAlert.fire({
      title: 'Confirm Action',
      text: 'Are you sure you want to remove this revision section?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
    }).then(async (alertResult) => {
      if (alertResult.isConfirmed) {
        let response;
        try {
          response = await prototypeApi.deleteRevisionDetails(
            revisionItem.pageComponentId,
          );
        } catch (error) {
          return;
        }
        if (response) {
          toast('Prototype revision deleted successfully', {
            type: 'success',
            autoClose: 5000,
          });
          setTimeout(() => {
            revisionViewToggle();
            window.location.reload();
          }, 2000);
        }
      }
    });
  };

  return (
    <div className="ar-common-content">
      <div className="ar-edit-page mw-100">
        <Row xs="1" sm="1" md="1">
          <Col className="sticky-top">
            <div className="ar-common-breadcrumb">
              <Link
                to={{
                  pathname: '/moodgen',
                }}
              >
                <button type="button" className="ar-common-breadcrumb__link">
                  Pages
                </button>
              </Link>
              <FontAwesomeIcon icon={faChevronRight} />
              <span className="ar-common-breadcrumb__page">
                Moodgen Builder
              </span>
            </div>
          </Col>
          <Col>
            <div className="ar-common-title">
              {' '}
              Moodgen Builder : {capitalize(pageName)}
              {pageMoodboardIsGenerating ? (
                <PageLoading loadingText="Generating moodboard. Please wait..." />
              ) : null}
            </div>
            <div>
              <FloatBtnGroup>
                <FloatBtn
                  variant="cancel"
                  type="button"
                  onClickHandler={handleCancel}
                  title="Back"
                />
                <FloatBtn
                  type="submit"
                  variant="update"
                  onClickHandler={handleSave}
                  title="Save"
                  disabled={!isLandingPageUpdated}
                />
                <FloatBtn
                  variant="figma"
                  type="button"
                  title="Generate Figma"
                  onClickHandler={() =>
                    handleMoodboardGenerate(prototypePageId)
                  }
                  disabled={pageMoodboardIsGenerating || items.length === 0}
                />
              </FloatBtnGroup>
              <div className="ar-edit-page__body border-0">
                <>
                  {isLoading && (
                    <PageLoading fullScreen loadingText="Loading sections..." />
                  )}
                  {responseCount === 0 && items.length === 0 && !isLoading && (
                    <div className="ar-common-page__empty">
                      <div className="ar-edit-page--empty text-center">
                        <h2 className="text-secondary">{pageName}</h2>
                        <h3>Let&apos;s start building the page!</h3>
                        <p>
                          Once you start adding new sections, you will see your
                          page being built here.
                        </p>
                        <button
                          type="button"
                          className="ar-btn ar-btn-outline--light rounded-pill mx-auto"
                          onClick={() => {
                            setAddSectionIndex(0);
                            handleAddNewClick(0);
                          }}
                        >
                          Add new sections
                        </button>
                      </div>
                    </div>
                  )}
                  <ReactSortable
                    list={items}
                    setList={setItems}
                    onChange={() => setIsLandingPageUpdated(true)}
                  >
                    {items.map((item, itemIndex) => (
                      <Fragment
                        key={item.pageComponentId || `${item.id}-${itemIndex}`}
                      >
                        <div className="ar-edit-page__wrapper ar-edit-page__options">
                          <div className="ar-edit-page__badges">
                            {item.isInRealm ? (
                              <span className="badge badge-pill badge-success realm-badge">
                                SBL
                              </span>
                            ) : null}
                            {item.isRevised ? (
                              <span className="badge badge-pill badge-success">
                                Revision
                              </span>
                            ) : null}
                            {item.isReference ? (
                              <span className="badge badge-pill badge-success">
                                Reference
                              </span>
                            ) : null}
                          </div>
                          <div className="ar-edit-page__image">
                            <div className="ar-edit-page__details">
                              <div className="ar-edit-page__project">
                                <span>{item.project}</span>
                                <span>{item.page}</span>
                              </div>
                              <div className="ar-edit-page__actions text-right">
                                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                                <button
                                  id={`revision-button-${item.id}-${itemIndex}`}
                                  type="button"
                                  className="ar-btn ar-btn--primary ar-btn--primary--revision ar-btn--icon-rounded"
                                  onClick={() => {
                                    if (!item.pageComponentId) {
                                      SweetAlert.fire({
                                        title: 'Save Changes',
                                        text: 'Please save the duplicated section before adding a revision.',
                                        icon: 'warning',
                                        confirmButtonText: 'Ok',
                                      });
                                    } else {
                                      createTempComponent(item, itemIndex + 1);
                                    }
                                  }}
                                  disabled={item.isReference}
                                />
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target={`revision-button-${item.id}-${itemIndex}`}
                                  trigger="hover"
                                >
                                  {item.isRevised ? 'View' : 'Add'} Revision
                                </UncontrolledTooltip>
                                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                                {/* Commented out as per the request of https://eight25media.atlassian.net/browse/ARGO-901 */}
                                {/* <button
                                  id={`duplicate-button-${item.id}-${itemIndex}`}
                                  type="button"
                                  className="ar-btn ar-btn--secondary ar-btn--secondary--duplicate ar-btn--icon-rounded"
                                  onClick={() =>
                                    handleDuplicate(item, itemIndex)
                                  }
                                />
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target={`duplicate-button-${item.id}-${itemIndex}`}
                                  trigger="hover"
                                >
                                  Duplicate Component
                                </UncontrolledTooltip> */}
                                <button
                                  id={`remove-button-${item.id}-${itemIndex}`}
                                  type="button"
                                  className="btn btn-danger rounded-circle"
                                  onClick={() => handleRemove(itemIndex)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target={`remove-button-${item.id}-${itemIndex}`}
                                  trigger="hover"
                                >
                                  Remove Component
                                </UncontrolledTooltip>

                                <div className="ar-edit-page__actions__move d-flex ml-2">
                                  <button
                                    id={`move-up-button-${item.id}`}
                                    type="button"
                                    className="ar-btn ar-btn--primary rounded-circle"
                                    onClick={() => handleMoveUp(itemIndex)}
                                  >
                                    <FontAwesomeIcon icon={faArrowUp} />
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`move-up-button-${item.id}`}
                                    trigger="hover"
                                  >
                                    Move Up
                                  </UncontrolledTooltip>

                                  <button
                                    id={`move-down-button-${item.id}`}
                                    type="button"
                                    className="ar-btn ar-btn--primary rounded-circle"
                                    onClick={() => handleMoveDown(itemIndex)}
                                  >
                                    <FontAwesomeIcon icon={faArrowDown} />
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`move-down-button-${item.id}`}
                                    trigger="hover"
                                  >
                                    Move Down
                                  </UncontrolledTooltip>

                                  <button
                                    id={`drag-screen-button-${item.id}-${itemIndex}`}
                                    type="button"
                                    className="ar-btn ar-btn--light ar-btn--light-drag rounded-circle"
                                    aria-label="Drag"
                                  />
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`drag-screen-button-${item.id}-${itemIndex}`}
                                    trigger="hover"
                                  >
                                    Drag and Drop
                                  </UncontrolledTooltip>
                                </div>
                              </div>
                            </div>
                            {(presentationModeIsDesign && item.designImage) ||
                            (!presentationModeIsDesign &&
                              item.wireFrameImage) ? (
                              <img
                                src={`${s3BucketUrl}/${
                                  presentationModeIsDesign
                                    ? formatImageUrl(item.designImage)
                                    : formatImageUrl(item.wireFrameImage)
                                }`}
                                alt="default component"
                                className="cover"
                              />
                            ) : (
                              <img
                                src={defaultComponentCover}
                                alt="default component"
                                className="cover"
                              />
                            )}
                          </div>
                          <MoodboardOptions
                            item={item}
                            prototypeId={prototypeId}
                            formatImageUrl={formatImageUrl}
                            presentationModeIsDesign={presentationModeIsDesign}
                            s3BucketUrl={s3BucketUrl}
                            defaultComponentCover={defaultComponentCover}
                          />
                          <div className="ar-edit-page__add-after">
                            <Button
                              id={`add-after-button-${item.id}`}
                              type="button"
                              className="ar-btn ar-btn--primary rounded-circle"
                              onClick={() => {
                                setAddSectionIndex(itemIndex);
                                handleAddNewClick(itemIndex + 1);
                              }}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </Button>
                            <UncontrolledTooltip
                              placement="bottom"
                              target={`add-after-button-${item.id}`}
                            >
                              Add Section Here
                            </UncontrolledTooltip>
                          </div>
                          {item.pageComponentId && (
                            <div className="ar-edit-page__grid-item-revisions">
                              {/* Revisions content */}
                            </div>
                          )}
                        </div>
                        {/* Moodboard references modal */}
                        {/* {selectedItem === item.pageComponentId && (
                        <div>
                          <MoodboardPopupConfig
                            key={item.pageComponentId}
                            item={item}
                            prototypeId={prototypeId}
                            setPopupClosed={setPopupClosed}
                            setSelectedItem={setSelectedItem}
                            formatImageUrl={formatImageUrl}
                            presentationModeIsDesign={presentationModeIsDesign}
                            s3BucketUrl={s3BucketUrl}
                            defaultComponentCover={defaultComponentCover}
                          />
                        </div>
                      )} */}
                      </Fragment>
                    ))}
                  </ReactSortable>
                </>
              </div>
            </div>
            {/* <div
              className="ar-edit-page__add-section"
              role="link"
              tabIndex={0}
              onKeyDown={() => handleAdd()}
              onClick={() => handleAdd()}
            >
              {' '}
              Add Sections
            </div> */}
          </Col>
        </Row>
      </div>

      {leaveAlertOpen && (
        <Alert
          onConfirm={() => {
            if (addSectionModal) {
              removeTempComponentAndCloseAddModal();
            } else {
              removeTempComponent();
            }
            setLeaveAlertOpen(false);
          }}
          onCancel={() => setLeaveAlertOpen(false)}
          open
        />
      )}
      {/* REVISION MODAL */}
      <Modal
        className="ar-edit-page__moodboard-popup"
        isOpen={revisionModal}
        toggle={() =>
          isRevisionUpdated ? setLeaveAlertOpen(true) : removeTempComponent()
        }
        size="xl"
      >
        <ModalHeader
          toggle={() =>
            isRevisionUpdated ? setLeaveAlertOpen(true) : removeTempComponent()
          }
          className="ar-edit-page__moodboard-popup-title ar-popup-close-btn"
        >
          <div className="container-fluid">
            <Row>
              <Col>Create revision</Col>
            </Row>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="ar-revision-popup">
            <div className="ar-revision-popup-image">
              <p className="ar-revision-popup-sub-heading">Original Design</p>
              <div className="ar-revision-popup-image-wrapper">
                {(presentationModeIsDesign &&
                  selectedRevisionItem?.designImage) ||
                (!presentationModeIsDesign &&
                  selectedRevisionItem?.wireFrameImage) ? (
                  <img
                    src={`${s3BucketUrl}/${
                      presentationModeIsDesign
                        ? formatImageUrl(selectedRevisionItem?.designImage)
                        : formatImageUrl(selectedRevisionItem?.wireFrameImage)
                    }`}
                    alt="Original Design"
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={defaultComponentCover}
                    alt="Original Design"
                    className="img-fluid"
                  />
                )}
                <div className="ar-revision-popup-image-action">
                  <div className="ar-revision-popup-image-action-row">
                    <p>Section Figma URL</p>
                    <Button
                      href={selectedRevisionItem?.sectionFigmaUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ar-btn ar-btn-outline--light"
                      disabled={!selectedRevisionItem?.sectionFigmaUrl}
                    >
                      Open in Figma
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="ar-revision-popup-add-files">
              <p className="ar-revision-popup-sub-heading">
                Add revision files
              </p>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={() => {
                  handleRevisionSubmit();
                }}
                validationSchema={validationSchema}
                innerRef={revisionFormRef}
              >
                {(formik) => {
                  const { values } = formik;

                  return (
                    <form>
                      {values.sections.map((section: any, index: number) => (
                        <Row
                          key={`section-${section.wireFrameImage || index}`}
                          className="mb-4"
                        >
                          <Col xs="12" md="6">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              {values.sections.length > 1 && (
                                <>
                                  <button
                                    id={`remove-section-revision-${index}`}
                                    type="button"
                                    className="btn btn-danger rounded-circle"
                                    onClick={() => removeSection(index)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`remove-section-revision-${index}`}
                                    trigger="hover"
                                  >
                                    Remove Section
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                            <DragAndDropField
                              previewStatus
                              uploading={
                                isFileUploading[`wireFrameImage_${index}`]
                              }
                              currentFileName={
                                section.wireFrameImage
                                  ? section.wireFrameImage
                                  : ''
                              }
                              name={`sections.${index}.wireFrameImage`}
                              label="Wire-frame Image*"
                              validFileTypes={['png', 'jpeg', 'jpg']}
                              fileType="wireFrameImage"
                              handleUploadFile={(event: any) =>
                                handleUploadFile(
                                  event,
                                  'wireFrameImage',
                                  values,
                                  index,
                                )
                              }
                            />
                            <ErrorMessage
                              name={`sections.${index}.wireFrameImage`}
                            >
                              {(msg) => (
                                <div
                                  className="error"
                                  style={{ marginTop: -25 }}
                                >
                                  {msg}
                                </div>
                              )}
                            </ErrorMessage>

                            <div className="form-group url-input">
                              <Label htmlFor={`sectionFigmaUrl_${index}`}>
                                Section Figma URL
                              </Label>
                              <Input
                                name={`sections.${index}.sectionFigmaUrl`}
                                className="form-control"
                                id={`sectionFigmaUrl_${index}`}
                                type="url"
                                value={section.sectionFigmaUrl}
                                onChange={formik.handleChange}
                              />
                              <ErrorMessage
                                name={`sections.${index}.sectionFigmaUrl`}
                              >
                                {(msg) => <div className="error">{msg}</div>}
                              </ErrorMessage>
                            </div>
                          </Col>
                        </Row>
                      ))}
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Row className="w-100">
            <Col xs="12" className="d-flex justify-content-end">
              <Button
                type="button"
                className="ar-btn ar-btn--ternary"
                onClick={() => handleRevisionSubmitRef()}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>

      {/* ADD NEW SECTION MODAL */}
      <Modal
        className="ar-edit-page__moodboard-popup"
        isOpen={addSectionModal}
        toggle={() =>
          isFormUpdated
            ? setLeaveAlertOpen(true)
            : removeTempComponentAndCloseAddModal()
        }
        size="xl"
      >
        <ModalHeader
          toggle={() =>
            isFormUpdated
              ? setLeaveAlertOpen(true)
              : removeTempComponentAndCloseAddModal()
          }
          className="ar-edit-page__moodboard-popup-title ar-popup-close-btn"
        >
          <div className="container-fluid">
            <Row>
              <Col>Add New Section</Col>
            </Row>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="ar-revision-popup">
            <div className="ar-revision-popup-add-files">
              <p className="ar-revision-popup-sub-heading">Add files</p>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={() => {
                  handleAddNewSubmit();
                }}
                validationSchema={validationSchema}
                innerRef={addNewFormRef}
              >
                {(formik) => {
                  const { values } = formik;

                  return (
                    <form>
                      {values.sections.map((section: any, index: number) => (
                        <Row
                          key={`new-section-${section.wireFrameImage || index}`}
                          className="mb-4"
                        >
                          <Col xs="12" md="6">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Section {index + 1}</h6>
                              {values.sections.length > 1 && (
                                <>
                                  <button
                                    id={`remove-section-new-${index}`}
                                    type="button"
                                    className="btn btn-danger rounded-circle"
                                    onClick={() => removeSection(index)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                  <UncontrolledTooltip
                                    placement="bottom"
                                    target={`remove-section-new-${index}`}
                                    trigger="hover"
                                  >
                                    Remove Section
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                            <DragAndDropField
                              previewStatus
                              uploading={
                                isFileUploading[`wireFrameImage_${index}`]
                              }
                              currentFileName={
                                section.wireFrameImage
                                  ? section.wireFrameImage
                                  : ''
                              }
                              name={`sections.${index}.wireFrameImage`}
                              label="Wire-frame Image*"
                              validFileTypes={['png', 'jpeg', 'jpg']}
                              fileType="wireFrameImage"
                              handleUploadFile={(event: any) =>
                                handleUploadFile(
                                  event,
                                  'wireFrameImage',
                                  values,
                                  index,
                                )
                              }
                            />
                            <ErrorMessage
                              name={`sections.${index}.wireFrameImage`}
                            >
                              {(msg) => (
                                <div
                                  className="error"
                                  style={{ marginTop: -25 }}
                                >
                                  {msg}
                                </div>
                              )}
                            </ErrorMessage>

                            <div className="form-group url-input">
                              <Label htmlFor={`sectionFigmaUrl_${index}`}>
                                Section Figma URL
                              </Label>
                              <Input
                                name={`sections.${index}.sectionFigmaUrl`}
                                className="form-control"
                                id={`sectionFigmaUrl_${index}`}
                                type="url"
                                value={section.sectionFigmaUrl}
                                onChange={formik.handleChange}
                              />
                              <ErrorMessage
                                name={`sections.${index}.sectionFigmaUrl`}
                              >
                                {(msg) => <div className="error">{msg}</div>}
                              </ErrorMessage>
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Row>
                        <Col xs="12">
                          <Button
                            type="button"
                            onClick={addNewSection}
                            className="ar-btn ar-btn--primary"
                          >
                            <FontAwesomeIcon
                              icon={faPlus}
                              className="me-2 mr-2"
                            />
                            Add Another Section
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Row className="w-100">
            <Col xs="12" className="d-flex justify-content-end">
              <Button
                type="button"
                className="ar-btn ar-btn--ternary"
                onClick={() => handleAddNewSubmitRef()}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>

      {/* VIEW/DELETE REVISION */}
      <Modal
        className="ar-edit-page__moodboard-popup"
        isOpen={revisionViewModal}
        toggle={revisionViewToggle}
        size="xl"
      >
        <ModalHeader
          toggle={revisionViewToggle}
          className="ar-edit-page__moodboard-popup-title ar-popup-close-btn"
        >
          <div className="container-fluid">
            <Row>
              <Col>Revision Details</Col>
            </Row>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="ar-revision-popup">
            <div className="ar-revision-popup-image">
              <p className="ar-revision-popup-sub-heading">
                Original Design
                <span className="ar-revision-popup-sub-heading-data">
                  Added date:{' '}
                  {moment(revisionItem?.originalComponent?.created_at).format(
                    'MM/DD/YYYY',
                  )}
                </span>
              </p>
              <div className="ar-revision-popup-image-wrapper">
                {(presentationModeIsDesign &&
                  revisionItem?.originalComponent?.design_image) ||
                (!presentationModeIsDesign &&
                  revisionItem?.originalComponent?.wire_frame_image) ? (
                  <img
                    src={`${s3BucketUrl}/${
                      presentationModeIsDesign
                        ? formatImageUrl(
                            revisionItem?.originalComponent?.design_image,
                          )
                        : formatImageUrl(
                            revisionItem?.originalComponent?.wire_frame_image,
                          )
                    }`}
                    alt="Original Design"
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={defaultComponentCover}
                    alt="Original Design"
                    className="img-fluid"
                  />
                )}
              </div>
            </div>
            <div className="ar-revision-popup-image">
              <p className="ar-revision-popup-sub-heading">
                Revision
                <span className="ar-revision-popup-sub-heading-data">
                  Added date:{' '}
                  {moment(revisionItem?.revisionComponent?.created_at).format(
                    'MM/DD/YYYY',
                  )}
                </span>
              </p>
              <div className="ar-revision-popup-image-wrapper">
                {(presentationModeIsDesign &&
                  revisionItem?.revisionComponent?.design_image) ||
                (!presentationModeIsDesign &&
                  revisionItem?.revisionComponent?.wire_frame_image) ? (
                  <img
                    src={`${s3BucketUrl}/${
                      presentationModeIsDesign
                        ? formatImageUrl(
                            revisionItem?.revisionComponent?.design_image,
                          )
                        : formatImageUrl(
                            revisionItem?.revisionComponent?.wire_frame_image,
                          )
                    }`}
                    alt="Original Design"
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={defaultComponentCover}
                    alt="Original Design"
                    className="img-fluid"
                  />
                )}
                <div className="ar-revision-popup-image-action">
                  <p>Delete Revision</p>
                  <Button
                    type="button"
                    className="ar-btn ar-btn-outline--light"
                    onClick={() => deleteRevision()}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Row className="w-100">
            <Col xs="12" className="d-flex justify-content-end">
              <Button
                type="button"
                className="ar-btn ar-btn--ternary"
                onClick={revisionViewToggle}
              >
                Done
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      {/* eslint-disable @typescript-eslint/no-unused-vars, consistent-return */}
      {isLandingPageUpdated && (
        <NavigationPrompt
          when={(crntLocation, nextLocation, _action) =>
            !nextLocation ||
            !nextLocation.pathname.startsWith(crntLocation.pathname)
          }
        >
          {({ onCancel, onConfirm }) => {
            if (isLandingPageUpdated) {
              return (
                <Alert
                  onConfirm={() => {
                    setIsLandingPageUpdated(false);
                    onConfirm();
                  }}
                  onCancel={onCancel}
                  open
                />
              );
            }

            setIsLandingPageUpdated(false);
            onConfirm();
          }}
        </NavigationPrompt>
      )}
    </div>
  );
};
export default EditPageMoodboard;
